import { toWsOrigin } from "../config/api";

export function buildWsUrl(path, token) {
  const apiBase =
    process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_BASE;
  const wsOrigin = toWsOrigin(apiBase);

  return `${wsOrigin}/api/v1/ws/${path}/?token=${token}`;
}
